export default function getRangeFromValues(values) {
    const years = values.map((item) => item.year);
    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);

    return [minYear, maxYear];
}